// extracted by mini-css-extract-plugin
export default {"header_menu":"headerMenu_header_menu__dK4uo","header_menu__item":"headerMenu_header_menu__item__uZZYw","header_menu__active_item":"headerMenu_header_menu__active_item__0-PlA"};